module.exports = __webpack_public_path__ + "img/AV_001_inicio_sinletras.0c0ab39d.jpg";